// extracted by mini-css-extract-plugin
export default {"layout":"CompanyFirstLogin_layout__81ebE","mainContainer":"CompanyFirstLogin_mainContainer__rRk0L","containerElement":"CompanyFirstLogin_containerElement__jGRIp"};